import RecordCreateUpdateAdditional from "./RecordCreateUpdateAdditional";
import RecordCreateSubitemsAdditional from "./RecordCreateSubitemsAdditional";

const AdditionalConfigSection = ({ action, setAction }) => {
  switch (action?.Type) {
    case "record-create-update":
      return (
        <RecordCreateUpdateAdditional action={action} setAction={setAction} />
      );
    case "record-create-update-subitems":
      return (
        <RecordCreateSubitemsAdditional action={action} setAction={setAction} />
      );
    default:
      return null;
  }
};

export default AdditionalConfigSection;
